/**
 * 微信公众号 H5 分享配置（JS-SDK）
 *
 * 依赖后端签名接口（项目已有，无需新开发）：
 *   POST https://taxpay.htzl.vip/wechat/wechat/jsJdk2
 *   参数：FormData { url }（当前页面完整地址，不含 # 及之后内容）
 *   返回：{ code:'0000', data: { timestamp, nonceStr, signature } }
 *
 * 使用前提：
 *   1. 公众号已开通「分享」类接口权限；
 *   2. 部署域名已配置为公众号 JS 安全域名；
 *   3. 分享图标必须是公网可访问的 https 绝对地址，本文件用当前域名 + 打包资源路径自动拼接。
 */
import wx from 'weixin-js-sdk'
import requestHTAPI from '@/axios/HantangTax'

// 分享图标：logoIco.jpg 经 webpack 打包后带 hash 路径，拼接当前域名生成微信要求的绝对地址
// （换图时替换 require 内的图片即可；微信建议 200x200 正方形、小于 300KB）
const SHARE_IMG_URL = `${window.location.origin}${require('@/assets/logoIco.jpg')}`

// 默认分享文案（链接默认分享当前页面，可在调用 configShare 时传参覆盖）
const DEFAULT_SHARE = {
  title: '智云众包平台',
  desc: '专业的灵活用工与众包服务平台',
  link: window.location.href.split('#')[0],
  imgUrl: SHARE_IMG_URL
}

/**
 * 配置微信分享（发送给朋友 + 分享到朋友圈）
 * @param {Object} share 可选，覆盖默认分享文案 { title, desc, link, imgUrl }
 */
export function configShare (share = {}) {
  // 开发环境无真实签名，跳过
  if (process.env.NODE_ENV === 'development') {
    console.log('开发环境跳过微信分享配置')
    return
  }
  const cfg = { ...DEFAULT_SHARE, ...share }

  // iOS 微信浏览器在 history 模式下需用首次进入页面的地址签名，否则签名失败
  let url = ''
  if (window.__wxjs_is_wkwebview === true) {
    url = window.entryUrl.split('#')[0]
  } else {
    url = window.location.href.split('#')[0]
  }

  const formData = new FormData()
  formData.append('url', url)

  requestHTAPI.jsJdk2(formData).then(res => {
    if (res.data.code !== '0000') {
      console.log('获取 JSSDK 签名失败', res.data.message)
      return
    }
    const { data } = res.data
    wx.config({
      debug: false, // 联调时可临时改为 true，客户端会 alert 出校验信息
      appId: process.env.VUE_APP_BASE_APPID, // 公众号唯一标识
      timestamp: data.timestamp, // 生成签名的时间戳
      nonceStr: data.nonceStr, // 生成签名的随机串
      signature: data.signature, // 签名
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline'
      ]
    })

    wx.ready(() => {
      // 新接口：发送给朋友（标题 + 描述 + 链接 + 右下角小图）
      wx.updateAppMessageShareData({
        title: cfg.title,
        desc: cfg.desc,
        link: cfg.link,
        imgUrl: cfg.imgUrl,
        success () {
          console.log('发送给朋友分享配置成功')
        }
      })

      // 新接口：分享到朋友圈（仅标题 + 链接 + 图，无描述）
      wx.updateTimelineShareData({
        title: cfg.title,
        link: cfg.link,
        imgUrl: cfg.imgUrl,
        success () {
          console.log('分享到朋友圈配置成功')
        }
      })

      // 低版本微信兼容接口（6.7.3 以下）
      wx.onMenuShareAppMessage({
        title: cfg.title,
        desc: cfg.desc,
        link: cfg.link,
        imgUrl: cfg.imgUrl,
        success () {},
        cancel () {}
      })
      wx.onMenuShareTimeline({
        title: cfg.title,
        link: cfg.link,
        imgUrl: cfg.imgUrl,
        success () {},
        cancel () {}
      })
    })
  }).catch(err => {
    console.log('JSSDK 签名请求失败', err)
  })
}

export default configShare
